import axios from 'axios';

import ICVUploadAnalytics from '../types/ICVUploadAnalytics';

const url = 'candidatesearch/api/';

export const getCVUploadAnalytics = (searchFilter: ICVUploadAnalytics) =>
  axios.post(`${url}get-cv-upload-analytics`, searchFilter);

export const getCvParsedAnalytics = (searchFilter: ICVUploadAnalytics) =>
  axios.post(`${url}get-cv-parsed-analytics`, searchFilter);

export const getCvParsedInLast24Analytics = (searchFilter: ICVUploadAnalytics) =>
  axios.post(`${url}get-cv-parsed-in-last-24-analytics`, searchFilter);

export const getCVUploadedByWorkspaceInLast30Days = (searchFilter: ICVUploadAnalytics) =>
  axios.post(`${url}get-cv-upload-30-days-analytics`, searchFilter);

export const getCVUploadAnalyticsDetails = (createdOn: ICVUploadAnalytics) =>
  axios.post(`${url}get-cv-upload-details-analytics`, createdOn);

export const getCVParsedTotalProcessedCountAnalytics = (createdOn: ICVUploadAnalytics[]) =>
  axios.post(`${url}get-cv-parsed-total-processed-count-analytics`, createdOn);

export const getloadCVUploadsByWorkspaceInLast30DaysCount = (createdOn: ICVUploadAnalytics) =>
  axios.post(`${url}get-cv-loads-by-workspace-in-last-30-days-analytics`, createdOn);

export const getLoadCVParsedStatusCount = (createdOn: ICVUploadAnalytics[]) =>
  axios.post(`${url}get-cv-parsed-status-count-analytics`, createdOn);

export const getCVParserStatusAdmin = (createdOn: ICVUploadAnalytics[]) =>
  axios.post(`${url}get-cv-parsed-status-count-analytics-by-workspace`, createdOn);

export const getCVParserStatusAdminWithIntervals = (createdOn: ICVUploadAnalytics[]) =>
  axios.post(`${url}get-cv-parsed-status-count-analytics-by-workspace-with-intervals`, createdOn);
